export const REDUCER_NAME = 'state-responsible'

export const LAST_CHANGE_TYPE_TASK = 'task'

export const LAST_CHANGE_TYPE_STATE = 'state'




// WEBPACK FOOTER //
// ./src/modules/analytics/state/state-responsible/const.js